module.exports = __webpack_public_path__ + "static/blog_grid_1-07df75e71906063b10f9df62b4fe0797.jpg";